// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__4kzTH","title":"Projects_title__DVb8C","projectContainer":"Projects_projectContainer__P4uyw"};